interface Area {
  name: string;
  modules: {
    [key: string]: string;
  };
  personalization_keys: {
    [key: string]: string;
  }
}

interface UserPreference {
  [key: string]: Area
}

export const managePageUserPreferenceStrings: UserPreference = {
  "budget_table": {
    "name": "manage_page_budget_table", // Controlled from backend (don't change without backend update)
    "modules": {}, // Controlled from backend (don't change without backend update)
    "personalization_keys": {
      "table_config": "ceg_table_config", // Controlled by frontend (think twice before update)
      "timeframe_config": "ceg_timeframe_config" // Controlled by frontend (think twice before update)
    }
  }
}
